import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const posAccessToken =
    authService.consumePosAccessTokenFromCurrentUrl();

  if (posAccessToken) {
    if (!authService.startPosSession(posAccessToken)) {
      authService.clearSession();

      return router.createUrlTree(['/login']);
    }

    return authService.hydrateRuntimePermissions().pipe(
      map(() => {
        /*
         * POS URL initially contains:
         * /bestellungen#token=...
         * or
         * /wareneingaenge#token=...
         *
         * After consuming the token, navigate once to the
         * same route without the sensitive URL fragment.
         */
        const cleanUrl =
          `${window.location.pathname}${window.location.search}`;

        return router.parseUrl(cleanUrl);
      }),

      catchError(() => {
        authService.clearSession();

        return of(
          router.createUrlTree(['/login'])
        );
      })
    );
  }

  if (authService.hasValidSession()) {
    if (authService.isPosSession() && authService.getAllowedModules().length === 0) {
      return authService.hydrateRuntimePermissions().pipe(
        map(() => true),
        catchError(() => {
          authService.clearSession();
          return of(router.createUrlTree(['/login']));
        })
      );
    }
    return true;
  }

  return router.createUrlTree(['/login']);
};